import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'


const url = 'tandc'
const plural = 'tandcs'
const single = 'tandc'

const api = new ApiCore({
	index: true,
	create: true,
	url: url,
	plural: plural,
	single: single
})


api.getTnC = (payload) => {


	return axios
		.get(`${apiProvider.BASE_URL}/tandc`,payload)
		.then(handleResponse)
		.catch(handleError);
}

api.acceptTnC = (payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/tandc`,payload)
		.then(handleResponse)
		.catch(handleError);
}

export default api
